import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19.114 5.638a9 9 0 0 1 0 12.728M16.463 8.29a5.25 5.25 0 0 1 0 7.425M6.75 8.252l4.72-4.72a.75.75 0 0 1 1.28.531v15.879a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.506-1.938-1.354a9 9 0 0 1-.322-2.396c0-.83.112-1.633.322-2.395.234-.848 1.058-1.355 1.937-1.355z"
    }, null, -1)
  ])))
}
export default { render: render }